/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var ExpensesIcon = createIcon("ExpensesIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 4H2C.897 4 0 4.897 0 6v12c0 1.103.897 2 2 2h20c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2Z",
    fill: "#71D571"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 4h-3a5 5 0 005 5V6c0-1.103-.897-2-2-2ZM0 6v3a5 5 0 005-5H2C.897 4 0 4.897 0 6Zm24 12v-3a5 5 0 00-5 5h3c1.103 0 2-.897 2-2ZM0 15v3c0 1.103.897 2 2 2h3a5 5 0 00-5-5Z",
    fill: "#179716"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#AEEFC6",
    cx: "12",
    cy: "12",
    rx: "3.5",
    ry: "5"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#179716",
    cx: "6",
    cy: "12",
    r: "1"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#179716",
    cx: "18",
    cy: "12",
    r: "1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 10.5h1.5v-1h-1V9h-1v.592c-.58.207-1 .757-1 1.408 0 .827.673 1.5 1.5 1.5a.5.5 0 010 1h-1.5v1h1v.5h1v-.592c.58-.207 1-.757 1-1.408 0-.827-.673-1.5-1.5-1.5a.5.5 0 010-1Z",
    fill: "#179716"
  })));
}, {});